const supportedTags = {
  '24v': { tooltip: 'Applicable for both communicating and 24v non-communicating equipment' },
  'EHMKT': { tooltip: 'Applicable for systems with HVAC Performance Monitoring Kits installed' }
}

export default supportedTags
